import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { betStore } from '@pascal/pascal-core/shared/core/store';
// eslint-disable-next-line no-unused-vars
import { LeftContainer } from '@pascal/pascal-core';
import { globalTranslationKeys } from '../../../enums';
import { ResultsWrapper } from '../resultsWrapper';
import { StatisticsWr } from '../statistics';

const LeftColumn = observer(() => {
  const { Results, Statistics } = globalTranslationKeys;
  const { repliedBetData } = betStore;
  const leftContainerTabs = useMemo(() => [{ name: Results }, { name: Statistics }], []);

  const leftContainerTabsContainers = useMemo(
    () => (repliedBetData ? [] : [<ResultsWrapper />, <StatisticsWr />]),
    [repliedBetData]
  );
  return (
    <LeftContainer
      hasAnimation
      tabs={leftContainerTabs}
      tabContainers={leftContainerTabsContainers}
    />
  );
});

export default LeftColumn;
